import { InputWithOptionsUniDriver } from '../InputWithOptions/InputWithOptions.uni.driver';

export interface AutoCompleteUniDriver extends InputWithOptionsUniDriver {}
